module.exports = __webpack_public_path__ + "static/media/Avatars_Female-26.a008209d.png";